// API Configuration for South Crete Tours
//
// process.env.NEXT_PUBLIC_* must be referenced with a literal key so Next.js
// can statically inline the value at build time. Dynamic bracket notation
// (e.g. process.env["NEXT_PUBLIC_..."]) is not replaced and evaluates to
// undefined on the client.
//
// Local XAMPP dev serves the PHP backend under /southcrete/manager/backend/api
// (port 80), while Next runs on :3003. Keep this as a development-only fallback.
const LOCAL_DEV_API_BASE_URL = "http://localhost/southcrete/manager/backend/api";
const DEFAULT_PROD_API_BASE_URL = "/backend/api";

function isManagerApiBase(value) {
  return /(?:^|[/.])manager\./i.test(String(value || "")) || /tk4uev6ka7fgm/i.test(String(value || ""));
}

function isBrowserCrossOriginApi(value) {
  if (!value || !/^https?:\/\//i.test(value)) return false;
  if (typeof window === "undefined" || !window.location?.origin) return false;
  try {
    return new URL(value).origin !== window.location.origin;
  } catch {
    return true;
  }
}

function resolveApiBaseUrl() {
  const envApi = String(process.env.NEXT_PUBLIC_API_BASE_URL || "").trim();

  // The browser must stay same-origin. Direct calls to XAMPP
  // (http://localhost/southcrete/manager/backend/api) from :3003 fail CORS.
  // next.config.mjs rewrites /backend/api to that PHP backend in development.
  if (typeof window !== "undefined") {
    if (envApi && !isManagerApiBase(envApi) && !isBrowserCrossOriginApi(envApi)) {
      return envApi;
    }
    return DEFAULT_PROD_API_BASE_URL;
  }

  if (envApi && !isManagerApiBase(envApi)) return envApi;
  return process.env.NODE_ENV === "production" ? DEFAULT_PROD_API_BASE_URL : LOCAL_DEV_API_BASE_URL;
}

const API_CONFIG = {
  baseURL: resolveApiBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

export default API_CONFIG;
